import React from 'react';
import { withRouter } from 'react-router-dom';
import GridPage from "../../grids/gridPage";
import CreateIncomingParcelModal from '../../modals/createIncomingParcelModal.jsx';
import { Button } from "semantic-ui-react";

class IncomingParcelsPage extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            showCreateModal: false,
            editingParcelId: null
        };

        this.createForm = null;
    }

    componentDidMount() {
        this.checkForNewAction();
        // Добавляем глобальную функцию для открытия модалки редактирования
        window.openIncomingParcelModal = (parcelId) => {
            this.openEditModal(parcelId);
        };
    }

    componentWillUnmount() {
        // Удаляем глобальную функцию при размонтировании компонента
        delete window.openIncomingParcelModal;
    }

    componentDidUpdate(prevProps) {
        // Проверяем изменился ли URL
        if (prevProps.location && this.props.location && 
            prevProps.location.pathname !== this.props.location.pathname) {
            this.checkForNewAction();
        }
    }

    checkForNewAction() {
        // Проверяем URL для автоматического открытия модального окна
        if (this.props.location && this.props.location.pathname.includes('/new')) {
            this.showCreateModal();
            // Заменяем URL без /new чтобы при обновлении страницы модальное окно не открывалось
            this.props.history.replace('/incoming-parcels');
        }
    }

    showCreateModal() {
        this.setState({ showCreateModal: true, editingParcelId: null });
    }

    hideCreateModal() {
        this.setState({ showCreateModal: false, editingParcelId: null });
    }

    openEditModal(parcelId) {
        this.setState({ showCreateModal: true, editingParcelId: parcelId });
    }

    handleCreateSuccess() {
        this.hideCreateModal();
        // GridPage сам обновится через reload
        window.location.reload();
    }

    render() {
        // Предопределенные колонки для входящих отправлений
        const columns = [
            {
                fieldName: 'number',
                title: 'Номер отправления',
                type: 'number',
                filterType: 'multiText',
                disableSort: false,
                canEdit: false
            },
            {
                fieldName: 'parcelType',
                title: 'Тип посылки',
                type: 'parcelType',
                filterType: 'select',
                disableSort: true,
                canEdit: false,
                options: [
                    { value: '', text: 'Все', key: 'all' },
                    { value: 'Документы', text: 'Документ', key: 'document' },
                    { value: 'Груз', text: 'Груз', key: 'cargo' }
                ]
            },
            {
                fieldName: 'receivedDate',
                title: 'Дата получения',
                type: 'receivedDate',
                filterType: 'date',
                disableSort: false,
                canEdit: false
            },
            // Новый столбец: Дата вручения
            {
                fieldName: 'deliveredDate',
                title: 'Дата вручения',
                type: 'deliveredDate',
                filterType: 'date',
                disableSort: false,
                canEdit: false
            },
            // Новый столбец: Статус
            {
                fieldName: 'status',
                title: 'Статус',
                type: 'status',
                filterType: 'select',
                disableSort: false,
                canEdit: false,
                options: [
                    { value: '', text: 'Все', key: 'all' },
                    { value: 'Received', text: 'Получено', key: 'received' },
                    { value: 'Delivered', text: 'Вручено', key: 'delivered' }
                ]
            },
            {
                fieldName: 'recipientName',
                title: 'Получатель',
                type: 'recipientName',
                filterType: 'text',
                disableSort: true,
                canEdit: false
            },
            {
                fieldName: 'senderName',
                title: 'Отправитель',
                type: 'senderName',
                filterType: 'text',
                disableSort: true,
                canEdit: false
            },
            {
                fieldName: 'comment',
                title: 'Комментарий',
                type: 'comment',
                filterType: 'text',
                disableSort: true,
                canEdit: false
            },
            {
                fieldName: 'receiptLocation',
                title: 'Место получения',
                type: 'receiptLocation',
                filterType: 'text',
                disableSort: true,
                canEdit: false
            },
            {
                fieldName: 'authorName',
                title: 'Автор посылки',
                type: 'authorName',
                filterType: 'text',
                disableSort: true,
                canEdit: false
            },
        ];

        return (
            <div>
                <GridPage
                    history={this.props.history}
                    gridName={'incoming-parcels'}
                    label={'Входящие отправления'}
                    isDictionary={true}
                    columns={columns}
                    dictionaryData={{ 
                        key: 'incoming-parcels',
                        createBtnText: 'Новое отправление'
                    }}
                />

                <CreateIncomingParcelModal
                    open={this.state.showCreateModal}
                    editingParcelId={this.state.editingParcelId}
                    onClose={() => this.hideCreateModal()}
                    onSuccess={() => this.handleCreateSuccess()}
                />
            </div>
        );
    }
}

export default withRouter(IncomingParcelsPage); 


// WEBPACK FOOTER //
// ./App/pages/incomingParcels/incomingParcelsPage.jsx